module.exports = __webpack_public_path__ + "static/media/Bg_header_2.e4e818d2.jpg";